import React, { useEffect, useState } from 'react';

import PurpleLoadingSpinner from '../../../../../assets/images/loading-spinner-purple.svg';
import { getDateRange } from '../../dashboard/cards/OpportunityCard';
import { MAP_IMG } from '../../../utils/contants';

export const OrganizationOpportunitesTab = ({
	orgID,
	opportunities,
	currentUserCanEdit,
	isFetchingOpportunities,
}) => {
	const [hasSavedDrafts, setHasSavedDrafts] = useState(false);
	const [hasPublishedOpportunities, setHasPublishedOpportunities] =
		useState(false);

	useEffect(() => {
		for (const opportunity of opportunities) {
			if (!opportunity.published) {
				setHasSavedDrafts(true);
			} else {
				setHasPublishedOpportunities(true);
			}
		}
	}, []);

	const redirectToCreateOpportunity = () => {
		location.assign(
			`/organizations/${orgID}/property_info/opportunities/new`
		);
	};

	if (isFetchingOpportunities) {
		return (
			<div style={{ textAlign: 'center' }}>
				<img
					id="purple-loading-spinner"
					src={PurpleLoadingSpinner}
					alt="Loading spinner"
				/>
			</div>
		);
	}

	if (opportunities?.length === 0) {
		return (
			<div className="opportunities-tab">
				{currentUserCanEdit ? (
					<div>
						<p className="body-font">
							Do you have an opportunity to share with potential
							sponsors?
						</p>
						<p className="body-font">
							Create your own page to allow for partnerships and
							connections to be made!
						</p>
						<div
							className="primary-button"
							onClick={redirectToCreateOpportunity}
						>
							<p>Create</p>
						</div>
					</div>
				) : (
					<div>
						<p>
							There doesn't seem to be any opportunities available
							to show yet, please check again at a later date!
						</p>
					</div>
				)}
			</div>
		);
	}

	return (
		<div className="opportunities-tab">
			{currentUserCanEdit ? (
				<div
					className="primary-button"
					onClick={redirectToCreateOpportunity}
				>
					<p>Create Opportunity</p>
				</div>
			) : (
				<></>
			)}

			{hasSavedDrafts && currentUserCanEdit ? (
				<div>
					<h6 className="header-font top-40px-margin">
						{' '}
						Saved Drafts{' '}
					</h6>

					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						{opportunities &&
							opportunities.map((opportunity, index) => {
								if (opportunity.published) {
									return;
								}

								return (
									<a
										href={`/organizations/${orgID}/property_info/opportunities/${opportunity.id}`}
										key={index}
										className="card opportunity-card open-modal card-md"
									>
										<p>
											<img
												style={{ width: '100%' }}
												src={MAP_IMG}
											/>
										</p>
										<p>
											{getDateRange(
												opportunity.timeframe_start_on,
												opportunity.timeframe_end_on
											)}
										</p>
										<h5>{opportunity.name}</h5>
										<p className="description-container">
											{opportunity.description}
										</p>
									</a>
								);
							})}
					</div>
				</div>
			) : (
				''
			)}

			{hasPublishedOpportunities ? (
				<h6 className="header-font top-40px-margin">
					Published Opportunities
				</h6>
			) : (
				''
			)}

			<div style={{ display: 'flex', flexWrap: 'wrap' }}>
				{opportunities &&
					opportunities.map((opportunity, index) => {
						if (!opportunity.published) {
							return;
						}

						return (
							<a
								href={`/organizations/${orgID}/property_info/opportunities/${opportunity.id}`}
								key={index}
								className="card opportunity-card open-modal card-md"
							>
								<p>
									<img
										style={{ width: '100%' }}
										src={MAP_IMG}
									/>
								</p>
								<p>
									{getDateRange(
										opportunity.timeframe_start_on,
										opportunity.timeframe_end_on
									)}
								</p>
								<h5>{opportunity.name}</h5>
								<p className="description-container">
									{opportunity.description}
								</p>
							</a>
						);
					})}
			</div>
		</div>
	);
};
